/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
/* Define the cart component */
import axios from "axios";
import {React} from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import config from "../../config/config";

function UpdateOrder(streamId, ovState) {

  const jsonData = {
    stream_id: streamId,
    };
 
  if (ovState === "WAITING") {
    const promise = axios(
      `${config.uiServerEndpoint}/manage/trigger/fovEntry`,
      {
        method: "post",
        data: jsonData,
      }
    );

    promise.then((response) => {
      console.log("FOV entry response: ", response.data);
    });

    promise.catch((e) => {
      console.error("FOV entry error:  ", e);
    });

  }
  else {
    const promise = axios(
      `${config.uiServerEndpoint}/manage/trigger/fovExit`,
      {
        method: "post",
        data: jsonData,
      }
    );

    promise.then((response) => {
      console.log("FOV exit response: ", response.data);
    });

    promise.catch((e) => {
      console.error("FOV exit error:  ", e);
    });
  }
};


function StartConversation() {
  const streamId = useSelector((state) => state.uuid.streamId);
  const ovState = useSelector((state) => state.ovState.ov);

  return (
    <Grid
      item
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        align: "center",
      }}
    >
      <Button
        size='medium'
        variant='contained'
        sx={{
          background: "#616161",
          borderRadius: "4px",
        }}

        onClick={() => {
          UpdateOrder(streamId, ovState);
        }}
      >
        <Box sx={{ display: { xs: "none", md: "inherit" } }}>
        { ovState === "WAITING" ? " Start ": " Stop "}
        </Box>
      </Button>
    </Grid>
  );
}

export default StartConversation;